import React, { useState } from 'react';
import { Button, FormDatePicker, FormSubmitButton, MasterDetailForm, Widget, notification } from '@digital/ui';
import { Modal, Row, Tooltip } from 'antd';
import * as Yup from 'yup';
import { useRecoilState, useRecoilValue } from 'recoil';
import { ordemCompraIdState, reloadVendorListState, dataLimiteEtapaState } from '../atoms';
import { criarAcoesVisitaTecnicaOrdemCompra } from '@app/api/sas/sasProposta';
import { Visibility } from '@app/components';

const ButtonSolicitarRespostaVisitaTecnica = () => {
  const ordemCompraId = useRecoilValue(ordemCompraIdState);
  const [reloadVendorList, setReloadVendorList] = useRecoilState(reloadVendorListState);
  const dataLimiteEtapa = useRecoilValue(dataLimiteEtapaState);
  const [open, setOpen] = useState(false);

  const onSubmit = (values: any) => {
    criarAcoesVisitaTecnicaOrdemCompra(ordemCompraId, values.dataLimite).then((data: any) => {
      if (data && data.valid) {
        setReloadVendorList(!reloadVendorList);
        setOpen(false);
      }
    });
  };

  return (
    <>
      <Tooltip title="Solicitar Resposta de Visita Técnica">
        <Button
          type="primary"
          style={{ float: 'right', marginRight: '5px' }}
          onClick={() => setOpen(true)}
        >
          Solicitar Resposta de Visita Técnica
        </Button>
      </Tooltip>
      <Visibility visible={open}>
        <Modal
          title="Solicitar Resposta de Visita Técnica"
          width="680px"
          visible={open}
          onCancel={() => setOpen(false)}
          footer={null}
        >
          <MasterDetailForm
            initialValues={{ dataLimite: undefined }}
            validationSchema={Yup.object().shape({
              dataLimite: Yup.string().nullable().required('Data limite é obrigatória'),
            })}
            actions={[
              <Button key="cancelarBtn" type="link" onClick={() => setOpen(false)}>
                Cancelar
              </Button>,
              <FormSubmitButton key="enviarBtn" title="Solicitar" noIcon type="primary" onClick={onSubmit} />,
            ]}
          >
            <Widget>
              <Row>
                <FormDatePicker
                  label="Data Limite de Resposta"
                  name="dataLimite"
                  format="DD/MM/YYYY"
                  span={4}
                  disabledDate={function(current) {
                    if (!dataLimiteEtapa) return false;
                    var limite = new Date(dataLimiteEtapa);
                    limite.setHours(23, 59, 59, 999);
                    return current && current.toDate() > limite;
                  }}
                />
              </Row>
              <Row>
                <p style={{ textAlign: 'center', paddingTop: '20px', paddingBottom: '20px' }}>
                  Deseja solicitar a resposta de visita técnica para todos os fornecedores ativos?
                </p>
              </Row>
            </Widget>
          </MasterDetailForm>
        </Modal>
      </Visibility>
    </>
  );
};

export default ButtonSolicitarRespostaVisitaTecnica;
